// ATL Form Request
;(function(w, d){
	var FORM_SELECTOR = '#atl-request-quote-form';
	var BUTTON_SELECTOR = '#atl-submit-btn';
	var MODAL_ID = 'atl-form-notice-modal';
	var BODY_OPEN_CLASS = 'atl-form-notice-modal-open';

	function init() {
		var form = d.querySelector(FORM_SELECTOR);
		if (!form) return;
		form.addEventListener('submit', handleSubmit);
	}

	function handleSubmit(event) {
		event.preventDefault();
		var form = event.target;
		var submitBtn = form.querySelector(BUTTON_SELECTOR);

		clearErrors(form);

		var errors = validate(form);
		if (Object.keys(errors).length) {
			renderErrors(form, errors);
			return;
		}

		setButtonLoading(submitBtn, true);
		setOverlay(form, true);

		send(form)
			.then(function(response){
				setButtonLoading(submitBtn, false);
				setOverlay(form, false);

				if (response.success) {
					var phoneInput = form.querySelector('#atl-phone-input');
					var normalizedPhone = (w.atlGetPhoneE164ForTracking && phoneInput)
						? w.atlGetPhoneE164ForTracking(phoneInput)
						: (form.querySelector('[name="atl-phone"]') ? form.querySelector('[name="atl-phone"]').value : '');
					// Store form data before showing success for Google Analytics tracking
					var formDataForTracking = {
						email: form.querySelector('[name="atl-email"]') ? form.querySelector('[name="atl-email"]').value : '',
						phone: normalizedPhone
					};

					// Google Analytics tracking with booking_id and total_value from response
					var bookingId = response.data && response.data.booking_id ? response.data.booking_id : null;
					var totalValue = response.data && response.data.total_value ? response.data.total_value : 0;
					trackGoogleAnalytics(bookingId, formDataForTracking, totalValue);

					redirectToCustomizeTour(form, response.data || {});
					
					return;
				}
				renderErrors(form, response.data.errors || {}, response.data.message);
				resetRecaptcha(form);
			})
			.catch(function(){
				setButtonLoading(submitBtn, false);
				setOverlay(form, false);
				renderErrors(form, {}, 'Something went wrong. Please try again.');
				resetRecaptcha(form);
			});
	}

	function ensureNoticeModal() {
		var modal = d.getElementById(MODAL_ID);
		if (modal) {
			return modal;
		}

		modal = d.createElement("div");
		modal.id = MODAL_ID;
		modal.className = 'atl-form-notice-modal';
		modal.setAttribute('hidden', 'hidden');
		modal.setAttribute('role', 'dialog');
		modal.setAttribute('aria-modal', 'true');
		modal.setAttribute('aria-labelledby', 'atl-form-notice-modal-title');
		var elTag = String.fromCharCode(100, 105, 118);

		var backdrop = d.createElement(elTag);
		backdrop.className = 'atl-form-notice-modal__backdrop';
		backdrop.setAttribute('data-atl-notice-close', '');

		var dialog = d.createElement(elTag);
		dialog.className = 'atl-form-notice-modal__dialog';

		var closeBtn = d.createElement('button');
		closeBtn.type = 'button';
		closeBtn.className = 'atl-form-notice-modal__close';
		closeBtn.setAttribute('data-atl-notice-close', '');
		closeBtn.setAttribute('aria-label', 'Close');
		closeBtn.innerHTML = '&times;';

		var iconWrap = d.createElement(elTag);
		iconWrap.className = 'atl-form-notice-modal__icon';
		iconWrap.setAttribute('aria-hidden', 'true');
		iconWrap.innerHTML = '<svg viewBox="0 0 24 24" width="28" height="28" focusable="false"><path fill="currentColor" d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-2h2v2zm0-4h-2V7h2v6z"/></svg>';

		var titleEl = d.createElement('h3');
		titleEl.id = 'atl-form-notice-modal-title';
		titleEl.className = 'atl-form-notice-modal__title';

		var messageEl = d.createElement('p');
		messageEl.className = 'atl-form-notice-modal__message';

		var okBtn = d.createElement('button');
		okBtn.type = 'button';
		okBtn.className = 'site-button atl-form-notice-modal__btn';
		okBtn.setAttribute('data-atl-notice-close', '');
		okBtn.textContent = 'OK';

		dialog.appendChild(closeBtn);
		dialog.appendChild(iconWrap);
		dialog.appendChild(titleEl);
		dialog.appendChild(messageEl);
		dialog.appendChild(okBtn);
		modal.appendChild(backdrop);
		modal.appendChild(dialog);
		d.body.appendChild(modal);

		modal.querySelectorAll('[data-atl-notice-close]').forEach(function(node) {
			node.addEventListener('click', hideNoticeModal);
		});

		d.addEventListener('keydown', function(ev) {
			if (ev.key === 'Escape' && modal.classList.contains('is-open')) {
				hideNoticeModal();
			}
		});

		return modal;
	}

	function showNoticeModal(options) {
		options = options || {};
		var modal = ensureNoticeModal();
		var type = options.type === 'info' ? 'info' : 'error';
		var titleEl = modal.querySelector('.atl-form-notice-modal__title');
		var messageEl = modal.querySelector('.atl-form-notice-modal__message');

		modal.classList.remove('atl-form-notice-modal--error', 'atl-form-notice-modal--info');
		modal.classList.add('atl-form-notice-modal--' + type);

		if (titleEl) {
			titleEl.textContent = options.title || (type === 'info' ? 'Notice' : 'Submission not completed');
		}
		if (messageEl) {
			// allowHtml chỉ dùng cho nội dung do admin cấu hình trong Theme Options.
			if (options.allowHtml) {
				messageEl.innerHTML = options.message || '';
			} else {
				messageEl.textContent = options.message || '';
			}
		}

		modal.removeAttribute('hidden');
		modal.classList.add('is-open');
		d.body.classList.add(BODY_OPEN_CLASS);

		var btn = modal.querySelector('.atl-form-notice-modal__btn');
		if (btn) {
			btn.focus();
		}
	}

	function hideNoticeModal() {
		var modal = d.getElementById(MODAL_ID);
		if (!modal) {
			return;
		}
		modal.classList.remove('is-open');
		modal.setAttribute('hidden', 'hidden');
		d.body.classList.remove(BODY_OPEN_CLASS);
	}

	function getRecaptchaResponse(form) {
		if (!w.grecaptcha || !w.grecaptcha.getResponse) {
			return '';
		}
		var el = form.querySelector('.g-recaptcha');
		var widgetId = el ? el.getAttribute('data-widget-id') : null;
		if (widgetId) {
			return w.grecaptcha.getResponse(parseInt(widgetId, 10)) || '';
		}
		return w.grecaptcha.getResponse() || '';
	}

	function resetRecaptcha(form) {
		if (!w.grecaptcha || !w.grecaptcha.reset) {
			return;
		}
		var el = form.querySelector('.g-recaptcha');
		var widgetId = el ? el.getAttribute('data-widget-id') : null;
		if (widgetId) {
			w.grecaptcha.reset(parseInt(widgetId, 10));
			return;
		}
		w.grecaptcha.reset();
	}

	function validate(form) {
		var errors = {};
		var required = [
			{ name: 'atl-agent-name', label: 'Agent name' },
			{ name: 'atl-full-name', label: 'Contact person' },
			{ name: 'atl-email', label: 'Email' },
			{ name: 'atl-confirm-email', label: 'Confirm email' },
			{ name: 'atl-phone', label: 'Phone number' },
			{ name: 'atl-message', label: 'Message' }
		];

		required.forEach(function(field){
			var input = form.querySelector('[name="' + field.name + '"]');
			if (!input || !input.value.trim()) {
				errors[field.name] = field.label + ' is required.';
			}
		});

		if (w.ATLValidation) {
			w.ATLValidation.checkNameField(form, 'atl-agent-name', 'Agent name', errors, true);
			w.ATLValidation.checkNameField(form, 'atl-full-name', 'Contact person', errors);
			w.ATLValidation.checkEmailField(form, 'atl-email', errors);
		}

		var email = form.querySelector('[name="atl-email"]');

		var confirm = form.querySelector('[name="atl-confirm-email"]');
		if (email && confirm && email.value !== confirm.value) {
			errors['atl-confirm-email'] = 'Email addresses do not match.';
		}

		if (!getRecaptchaResponse(form)) {
			errors.recaptcha = 'Please complete the reCAPTCHA verification.';
		}

		return errors;
	}

	function redirectToCustomizeTour(form, responseData) {
		var redirectUrl = responseData.redirect_url || '/customized-tour';
		var url = new URL(redirectUrl, w.location.origin);
		var prefillPayload = {
			quick_request: 1,
			agent_name: getInputValue(form, 'atl-agent-name'),
			full_name: getInputValue(form, 'atl-full-name'),
			phone: getInputValue(form, 'atl-phone'),
			email: getInputValue(form, 'atl-email'),
			confirm_email: getInputValue(form, 'atl-confirm-email'),
			message: getInputValue(form, 'atl-message')
		};

		try {
			sessionStorage.setItem('atl_quick_request_prefill', JSON.stringify(prefillPayload));
		} catch (e) {
			console.warn('Cannot save quick request prefill', e);
		}

		url.search = '';
		w.location.href = url.toString();
	}

	function getInputValue(form, fieldName) {
		var input = form.querySelector('[name="' + fieldName + '"]');
		return input && input.value ? input.value.trim() : '';
	}

	function send(form) {
		var data = new FormData(form);
		var phoneInput = form.querySelector('#atl-phone-input');

		if (phoneInput && w.intlTelInputGlobals) {
			var instance = w.intlTelInputGlobals.getInstance && w.intlTelInputGlobals.getInstance(phoneInput);
			if (instance) {
				data.append('atl-phone-full', instance.getNumber());
				var country = instance.getSelectedCountryData();
				if (country) {
					data.append('atl-phone-country-code', '+' + country.dialCode);
					data.append('atl-phone-country-iso', country.iso2);
				}
			}
		}

		// Gửi thêm thông tin IP user nếu đã được detect và cache ở frontend
		try {
			var ipInfo = localStorage.getItem('atl_info_ip');
			if (ipInfo) {
				data.append('dataIpUser', ipInfo);
			}
		} catch (e) {
			console.warn('Cannot access localStorage for IP info', e);
		}

		var recaptchaToken = getRecaptchaResponse(form);
		if (recaptchaToken) {
			data.append('g-recaptcha-response', recaptchaToken);
		}

		data.append('action', 'atl_submit_request_quote');

		var ajaxUrl = (w.atlConfigAjax && w.atlConfigAjax.ajax_url) ? w.atlConfigAjax.ajax_url : '/wp-admin/admin-ajax.php';

		return fetch(ajaxUrl, {
			method: 'POST',
			body: data
		}).then(function(res){ return res.json(); });
	}

	function renderErrors(form, errors, message) {
		Object.keys(errors).forEach(function(field){
			if (field === 'recaptcha') {
				var recaptchaError = form.querySelector('#atl-request-recaptcha-error');
				if (recaptchaError) {
					recaptchaError.textContent = errors[field];
					recaptchaError.style.display = 'block';
				}
				return;
			}

			var input = form.querySelector('[name="' + field + '"]');
			var group = input ? input.closest('.form-group') : null;
			var label = group ? group.querySelector('.atl-field-error') : null;

			if (label) {
				label.textContent = errors[field];
				label.style.display = 'block';
			}

			if (input) {
				input.classList.add('atl-field-has-error');
			}
		});

		if (message && !Object.keys(errors).length) {
			showNoticeModal({
				type: 'error',
				message: message
			});
		}
	}

	function clearErrors(form) {
		hideNoticeModal();
		form.querySelectorAll('.atl-field-error').forEach(function(el){
			el.textContent = '';
			el.style.display = 'none';
		});
		form.querySelectorAll('.atl-form-control').forEach(function(el){
			el.classList.remove('atl-field-has-error');
		});
		var recaptchaError = form.querySelector('#atl-request-recaptcha-error');
		if (recaptchaError) {
			recaptchaError.textContent = '';
			recaptchaError.style.display = 'none';
		}
	}

	function setButtonLoading(btn, loading) {
		if (!btn) return;
		if (loading) {
			btn._text = btn.textContent;
			btn.disabled = true;
			btn.textContent = 'Sending...';
		} else {
			btn.disabled = false;
			btn.textContent = btn._text || 'Send Enquiry';
		}
	}

	function setOverlay(form, show) {
		var container = form.closest('.section-content') ||
			form.closest('.widget.detail-tour-form') ||
			form;

		if (!container) return;

		if (getComputedStyle(container).position === 'static') {
			container.style.position = 'relative';
		}

		var overlay = container.querySelector('.atl-form-loading-overlay');
		if (!overlay) {
			overlay = d.createElement('div');
			overlay.className = 'atl-form-loading-overlay';
			overlay.innerHTML = '<div class="atl-loading-pic"><div class="loader"></div></div>';
			container.appendChild(overlay);
		}

		overlay.style.display = show ? 'block' : 'none';
	}

	function showSuccess(form) {
		var content = form.querySelector('.atl-form-content');
		var success = form.querySelector('.atl-success-message');

		if (content) content.style.display = 'none';
		if (success) {
			if (w.atlRevealSuccessWithConsultant) {
				w.atlRevealSuccessWithConsultant(success).then(function() {
					form.scrollIntoView({ behavior: 'smooth', block: 'start' });
				});
				return;
			}
			success.style.display = 'block';
		}
		form.scrollIntoView({ behavior: 'smooth', block: 'start' });
	}

	// Google Analytics tracking function
	function trackGoogleAnalytics(requestCode, formData, totalValue) {
		// Check if gtag is available
		if (typeof w.gtag === 'undefined') {
			console.log('Google Analytics gtag not available');
			return;
		}

		// Get user data from stored form data
		var userEmail = formData ? formData.email : '';
		var userPhone = formData ? formData.phone : '';
		
		// Use provided requestCode or empty string
		var finalRequestCode = requestCode || '';
		
		// Use provided totalValue or default to 0
		var finalTotalValue = totalValue !== undefined ? totalValue : 0;
		
		console.log('Tracking Google Analytics conversion:', {
			email: String(userEmail),
			phone: String(userPhone),
			requestCode: String(finalRequestCode),
			totalValue: finalTotalValue
		});

		// Execute custom tracking script from admin settings
		executeCustomTrackingScript(userEmail, userPhone, finalRequestCode, finalTotalValue);
	}

	// Execute custom tracking script from admin settings
	function executeCustomTrackingScript(userEmail, userPhone, requestCode, totalValue) {
		// Check if custom script is available from admin settings
		if (w.atlCustomScripts && w.atlCustomScripts.page_after_submit_js) {
			var customScript = w.atlCustomScripts.page_after_submit_js;
			
			// Replace placeholders with actual values, keeping the single quotes
			var scriptToExecute = customScript
				.replace(/'USER_EMAIL'/g, "'" + String(userEmail) + "'")
				.replace(/'USER_PHONE'/g, "'" + String(userPhone) + "'")
				.replace(/'REQUESTCODE'/g, "'" + String(requestCode) + "'")
				.replace(/TOTALVALUE/g, String(totalValue));
			
			console.log('Executing custom tracking script:', scriptToExecute);
			
			try {
				// Execute the custom script
				console.log(scriptToExecute);
				eval(scriptToExecute);
			} catch (error) {
				console.error('Error executing custom tracking script:', error);
			}
		}
	}

	if (typeof w.ATLFormRequest === 'undefined') {
		w.ATLFormRequest = {};
	}
	w.ATLFormRequest.init = init;
	w.ATLFormRequest.showNoticeModal = showNoticeModal;
	w.ATLFormRequest.hideNoticeModal = hideNoticeModal;

	if (d.readyState === 'loading') {
		d.addEventListener('DOMContentLoaded', init);
	} else {
		init();
	}
})(window, document);
